import AddGradeStep from "./AddGradeStep";
import SingleGradeStep from "./SingleGradeStep";


const GradeStepsMain = ({gradeSteps, setGradeSteps}) => {
 
    const addStep = (step) => {
        setGradeSteps([...gradeSteps, step]);
    }
    const editStep = (step) => {
        const updatedSteps = gradeSteps.map((s) =>  s._id=== step._id ? step : s);
        setGradeSteps(updatedSteps);
    }
    const deleteStep = (step) => {
        const updatedSteps = gradeSteps.filter((s) => s._id !== step._id);
        setGradeSteps(updatedSteps);
    }
    const orderedSteps = [...gradeSteps].sort((a, b) => a.order - b.order);
    const totalGrade = orderedSteps.reduce((total, step) => total +  ( Number( step.baseGrade) || 0), 0);

  return (
    <>
    {orderedSteps && orderedSteps.length > 0 ? (<>
{orderedSteps.map((step, index) => (<SingleGradeStep  key={index} gradeStep={step} editStep={editStep}  deleteStep={deleteStep} />))}
<span className="text-xlg font-semibold p-2">סה"כ: {totalGrade}%</span>
   </> ) : (
        <div className="text-center text-gray-500">No grade steps available</div>
    )}
    <div className="mt-4">
        <AddGradeStep addStep={addStep} gradeSteps={gradeSteps}  /> 
    </div> 
    </>
  )
}

export default GradeStepsMain